function onlyNumbers(value) {
  if (typeof value === 'string') {
    return value.replace(/[^\d]+/g, '');
  }

  return value;
}

function stripCnpjMask(value) {
  if (typeof value === 'string') {
    return value.replace(/[.\s/-]/g, '').toUpperCase();
  }

  return value;
}

export { onlyNumbers, stripCnpjMask };
